module.exports = __webpack_public_path__ + "img/protected.5322504c.svg";